<form
  [formGroup]="singleProductForm"
  class="rc-card product-card"
  [class.rc-card--selected]="isSelected(product)"
  [id]="'product-id-' + product.id"
>
  <img class="picture" (click)="showDetailPopin()" [src]="product.image | publicUrl: product.productType" alt="{{ product.name || '' }}" />
  <p class="category">
    {{ product.productType | translationCode: LocaleContentEnum.ProductType }}
  </p>
  <div class="title-wrapper">
    <h1
      class="rc-title-beta title"
      [matTooltipPosition]="'below'"
      matTooltipHideDelay="1"
      matTooltip="{{ product.name }}"
      #tooltip="matTooltip"
      matTooltipClass="tooltip-arrow-up"
      (click)="showDetailPopin()"
    >
      {{ product.name || '--' }}
    </h1>
  </div>
  @if (showSelectButton) {
    <rc-button data-qa="vs-product-card-button-product-details" id="show-product-detail" class="detail-button" (click)="showDetailPopin()">
      {{ 'action_product-detail' | translateKey }}
    </rc-button>
  }
  <div class="packages">
    <div
      class="rc-select"
      [class.package-sk]="!displayPackages"
      [class.product__selector]="displayPackages"
      [class.rc-select]="displayPackages"
      [class.left]="displayPackages"
    >
      @if (displayPackages) {
        <rc-select
          [id]="'product-card-select-' + product.id"
          formControlName="packId"
          [customSort]="customSelectSort"
          [items]="packageItems"
          [hideLabel]="true"
        ></rc-select>
      } @else {
        @if (product.packages[0]) {
          <span class="product__selector--disabled left">{{ product.packages[0].text }}</span>
          @if (showWholesalePrices$ | async) {
            <p class="price" id="productPrice--{{ product.id }}">
              {{ getWholesalePrice$(product.packages[0].sCode) | async | currency: (clinicCurrency$ | async) }}
            </p>
          }
        }
      }
    </div>
    @if (showRetailPrices$ | async) {
      <p class="price" id="productPrice--{{ product.id }}">
        {{ getProductPrice() | currency: (clinicCurrency$ | async) }}
      </p>
    }

    @if (
      displayPackages && (showWholesalePrices$ | async) && (getWholesalePrice$(singleProductForm?.get('packId')?.value) | async);
      as wholesalePrice
    ) {
      <p class="price" id="productPrice--{{ product.id }}">
        {{ wholesalePrice | currency: (clinicCurrency$ | async) }}
        <span>*</span>
      </p>
    }
  </div>

  @if (!showSelectButton) {
    @if (!disableDetailsButton) {
      <rc-button data-qa="vs-product-card-button-details" variant="secondary-alt" (click)="showDetailPopin()">
        {{ 'action_detail' | translateKey }}
      </rc-button>
    }
  } @else {
    <rc-button
      id="select-product-{{ product.id }}"
      data-qa="vs-product-card-button-select-deselect"
      [variant]="isSelected(product) ? 'secondary-alt' : 'primary'"
      type="submit"
      (click)="didSelectProduct(product)"
    >
      {{ !isSelected(product) ? (selectButtonLabel || 'action_select' | translateKey) : ('action_deselect' | translateKey) }}
    </rc-button>
  }
</form>
